import { createAsyncThunk } from '@reduxjs/toolkit';
import { post } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import { selectMissingEntityIds } from '~SpectateStore/selectors/domains/translatedEntityIdsSelectors';

export const translateEntityIds = createAsyncThunk(
    'translateEntityIds',
    async ({ from, to, events = [], selections = [] }, { rejectWithValue }) => {
        const response = await post(
            buildSpectateUrl('/translateEntityIds'),
            { selections, events, from, to },
        );

        if (!response.ok) {
            return rejectWithValue({});
        }

        const { events: translatedEvents, selections: translatedSelections } = await response.json();

        return {
            from,
            to,
            requestedEvents: events,
            requestedSelections: selections,
            events: translatedEvents ?? {},
            selections: translatedSelections ?? {},
        };
    },
);

export const requestEntityIdsTranslation = ({ from, to, events = [], selections = [] }) =>
    (dispatch, getState) => {
        const { events: missingEvents, selections: missingSelections } = selectMissingEntityIds(
            getState(),
            { from, to, events, selections },
        );

        if (!missingEvents.length && !missingSelections.length) {

            return;
        }

        dispatch(translateEntityIds({
            from,
            to,
            events: missingEvents,
            selections: missingSelections,
        }));
    };
